import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "../DealsAndOffers/dealsAndOffers.css";
import ListResaleProperties from "../Properties Resale/listResaleProperties";
import ListInterestedPropertyResale from "../Properties Resale/listInterestedPropertyResale";
import "./headerResaleProperty.css";
import { Skeleton } from "antd";

// const STORAGE_KEY = "agent_header_tab";

const HeaderResaleProperty = () => {
  const [selectedTable, setSelectedTable] = useState("list");
  const [loading, setLoading] = useState(false);


  const handleTableSelection = (table) => {
    if (table === selectedTable || loading) return;

    setLoading(true);
    setSelectedTable(table);
    // localStorage.setItem(STORAGE_KEY, table);

    setTimeout(() => {
      setLoading(false);
    }, 400);
  };

  return (
    <MainLayout>
      <div className="dealsAndOffers-container">
        <div className={`bg-white border-10 padding-10 shadow-box ${loading ? "disabled-tabs" : ""}`}
          style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", marginBottom: "20px" }}>
          <div className="hover_panel">
            <h4
              className={selectedTable === "list" ? "clicked" : ""}
              onClick={() => handleTableSelection("list")}
            >
              Property Types
            </h4>

            <h4
              className={selectedTable === "interested_list" ? "clicked" : ""}
              onClick={() => handleTableSelection("interested_list")}
            >
              Interested Property
            </h4>
          </div>
        </div>

        {loading && (
          <div className="tab-loader">
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        )}

        <div className={`fade-wrapper ${loading ? "hide" : ""}`}>
          <div style={{ display: selectedTable === "list" ? "block" : "none" }}>
            <ListResaleProperties />
          </div>

          <div style={{ display: selectedTable === "interested_list" ? "block" : "none" }}>
            <ListInterestedPropertyResale />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default HeaderResaleProperty;
